import React from 'react';

const SCENE: React.CSSProperties = {
  position: 'relative',
  width: 320,
  height: 320,
  flexShrink: 0,
};

const styles = `
  .nvp-phone-wrap {
    animation: nvp-phone-bob 3.2s ease-in-out infinite;
    transform-origin: 30px 100px;
    transform-box: fill-box;
  }
  @keyframes nvp-phone-bob {
    0%, 100% { transform: rotate(-8deg) translateY(0); }
    25% { transform: rotate(-12deg) translateY(-3px); }
    50% { transform: rotate(-5deg) translateY(-1px); }
    75% { transform: rotate(-10deg) translateY(-2px); }
  }
  .nvp-beam { animation: nvp-beam 2s ease-in-out infinite; }
  @keyframes nvp-beam {
    0% { transform: translateY(0); opacity: 0; }
    8% { opacity: 1; }
    48% { transform: translateY(30px); opacity: 1; }
    52% { transform: translateY(30px); opacity: 1; }
    92% { transform: translateY(0); opacity: 1; }
    100% { transform: translateY(0); opacity: 0; }
  }
  .nvp-cm { animation: nvp-cm 1.4s ease-in-out infinite; }
  @keyframes nvp-cm {
    0%, 100% { opacity: 0.45; }
    50% { opacity: 1; }
  }
  .nvp-check {
    animation: nvp-check 2s ease-in-out infinite;
    transform-origin: 52px 36px;
    transform-box: fill-box;
  }
  @keyframes nvp-check {
    0%, 85% { opacity: 0; transform: scale(0); }
    90% { opacity: 1; transform: scale(1.4); }
    96%, 100% { opacity: 1; transform: scale(1); }
  }
`;

export default function PhoneIllustration() {
  return (
    <>
      <style>{styles}</style>
      <div style={SCENE} aria-hidden="true">
        <svg viewBox="0 0 320 320" xmlns="http://www.w3.org/2000/svg" style={{ width: '100%', height: '100%' }}>
          <circle cx="160" cy="170" r="140" fill="#D6F0EA"/>
          <circle cx="80" cy="80" r="40" fill="#B7E6DB" opacity="0.6"/>
          <circle cx="260" cy="90" r="22" fill="#B7E6DB" opacity="0.8"/>
          <circle cx="245" cy="130" r="18" fill="#F59E0B" stroke="#B45309" strokeWidth="2"/>
          <text x="245" y="136" textAnchor="middle" fontSize="16" fontWeight="800" fill="#78350F">$</text>
          <rect x="40" y="155" width="42" height="26" rx="3" fill="#15A08C" stroke="#0F6E56" strokeWidth="1.5"/>
          <circle cx="61" cy="168" r="7" fill="#DCFCE7" stroke="#0F6E56" strokeWidth="1"/>
          <text x="61" y="171" textAnchor="middle" fontSize="7" fontWeight="800" fill="#0F6E56">$</text>
          <circle cx="60" cy="240" r="12" fill="#F59E0B" stroke="#B45309" strokeWidth="1.5"/>
          <text x="60" y="244" textAnchor="middle" fontSize="11" fontWeight="800" fill="#78350F">$</text>
          <path d="M 130 290 L 135 230 L 165 230 L 170 290 L 155 290 L 150 240 L 145 290 Z" fill="#1E293B"/>
          <path d="M 115 230 Q 115 170 150 165 L 165 165 Q 185 170 185 230 Z" fill="#F97066"/>
          <path d="M 142 170 L 150 185 L 158 170 Z" fill="#FEE2E2"/>
          <rect x="146" y="155" width="12" height="15" fill="#D4A574"/>
          <circle cx="152" cy="140" r="22" fill="#D4A574"/>
          <path d="M 130 135 Q 130 115 152 112 Q 174 115 174 135 Q 174 128 170 125 Q 165 120 158 120 Q 150 120 145 123 Q 138 126 132 130 Q 130 132 130 135 Z" fill="#1E293B"/>
          <circle cx="146" cy="140" r="1.5" fill="#1E293B"/>
          <circle cx="158" cy="140" r="1.5" fill="#1E293B"/>
          <path d="M 148 148 Q 152 151 156 148" stroke="#1E293B" strokeWidth="1.5" fill="none" strokeLinecap="round"/>
          <path d="M 185 180 Q 215 180 220 215 L 215 230 Q 200 215 185 205 Z" fill="#F97066"/>

          <g transform="translate(195, 180)">
            <g className="nvp-phone-wrap">
              <rect x="0" y="0" width="60" height="100" rx="8" fill="#1E293B"/>
              <rect x="3" y="12" width="54" height="80" rx="2" fill="#FFFFFF"/>
              <rect x="3" y="12" width="54" height="16" rx="2" fill="#0F6E56"/>
              <text x="30" y="23" textAnchor="middle" fontSize="8" fontWeight="800" fill="#FFFFFF">Novala Pay</text>
              <g transform="translate(12, 32)">
                <rect x="0" y="0" width="36" height="36" fill="#FFFFFF" stroke="#1E293B" strokeWidth="0.6"/>
                <rect x="2" y="2" width="9" height="9" fill="#1E293B"/>
                <rect x="4" y="4" width="5" height="5" fill="#FFFFFF"/>
                <rect x="5.5" y="5.5" width="2" height="2" fill="#1E293B"/>
                <rect x="25" y="2" width="9" height="9" fill="#1E293B"/>
                <rect x="27" y="4" width="5" height="5" fill="#FFFFFF"/>
                <rect x="28.5" y="5.5" width="2" height="2" fill="#1E293B"/>
                <rect x="2" y="25" width="9" height="9" fill="#1E293B"/>
                <rect x="4" y="27" width="5" height="5" fill="#FFFFFF"/>
                <rect x="5.5" y="28.5" width="2" height="2" fill="#1E293B"/>
                <rect x="13" y="2" width="2" height="2" fill="#1E293B"/>
                <rect x="17" y="2" width="2" height="2" fill="#1E293B"/>
                <rect x="21" y="2" width="2" height="2" fill="#1E293B"/>
                <rect x="15" y="5" width="2" height="2" fill="#1E293B"/>
                <rect x="19" y="5" width="2" height="2" fill="#1E293B"/>
                <rect x="23" y="5" width="2" height="2" fill="#1E293B"/>
                <rect x="13" y="8" width="2" height="2" fill="#1E293B"/>
                <rect x="17" y="8" width="2" height="2" fill="#1E293B"/>
                <rect x="21" y="8" width="2" height="2" fill="#1E293B"/>
                <rect x="2" y="13" width="2" height="2" fill="#1E293B"/>
                <rect x="6" y="13" width="2" height="2" fill="#1E293B"/>
                <rect x="10" y="13" width="2" height="2" fill="#1E293B"/>
                <rect x="14" y="13" width="2" height="2" fill="#1E293B"/>
                <rect x="18" y="13" width="4" height="2" fill="#1E293B"/>
                <rect x="24" y="13" width="2" height="2" fill="#1E293B"/>
                <rect x="28" y="13" width="2" height="2" fill="#1E293B"/>
                <rect x="32" y="13" width="2" height="2" fill="#1E293B"/>
                <rect x="4" y="16" width="2" height="2" fill="#1E293B"/>
                <rect x="8" y="16" width="2" height="2" fill="#1E293B"/>
                <rect x="12" y="16" width="4" height="2" fill="#1E293B"/>
                <rect x="18" y="16" width="2" height="2" fill="#1E293B"/>
                <rect x="22" y="16" width="2" height="2" fill="#1E293B"/>
                <rect x="26" y="16" width="2" height="2" fill="#1E293B"/>
                <rect x="30" y="16" width="2" height="2" fill="#1E293B"/>
                <rect x="2" y="19" width="2" height="2" fill="#1E293B"/>
                <rect x="6" y="19" width="2" height="2" fill="#1E293B"/>
                <rect x="14" y="19" width="2" height="2" fill="#1E293B"/>
                <rect x="20" y="19" width="4" height="2" fill="#1E293B"/>
                <rect x="26" y="19" width="2" height="2" fill="#1E293B"/>
                <rect x="30" y="19" width="2" height="2" fill="#1E293B"/>
                <rect x="4" y="22" width="2" height="2" fill="#1E293B"/>
                <rect x="10" y="22" width="2" height="2" fill="#1E293B"/>
                <rect x="18" y="22" width="2" height="2" fill="#1E293B"/>
                <rect x="24" y="22" width="2" height="2" fill="#1E293B"/>
                <rect x="28" y="22" width="2" height="2" fill="#1E293B"/>
                <rect x="32" y="22" width="2" height="2" fill="#1E293B"/>
                <rect x="13" y="26" width="2" height="2" fill="#1E293B"/>
                <rect x="19" y="26" width="2" height="2" fill="#1E293B"/>
                <rect x="23" y="26" width="4" height="2" fill="#1E293B"/>
                <rect x="29" y="26" width="2" height="2" fill="#1E293B"/>
                <rect x="33" y="26" width="2" height="2" fill="#1E293B"/>
                <rect x="15" y="29" width="2" height="2" fill="#1E293B"/>
                <rect x="21" y="29" width="4" height="2" fill="#1E293B"/>
                <rect x="27" y="29" width="2" height="2" fill="#1E293B"/>
                <rect x="31" y="29" width="2" height="2" fill="#1E293B"/>
                <rect x="13" y="32" width="2" height="2" fill="#1E293B"/>
                <rect x="17" y="32" width="2" height="2" fill="#1E293B"/>
                <rect x="25" y="32" width="2" height="2" fill="#1E293B"/>
                <rect x="31" y="32" width="2" height="2" fill="#1E293B"/>
                <path className="nvp-cm" d="M -1 -1 L -1 4 M -1 -1 L 4 -1" stroke="#15A08C" strokeWidth="1.2" fill="none"/>
                <path className="nvp-cm" d="M 37 -1 L 37 4 M 37 -1 L 32 -1" stroke="#15A08C" strokeWidth="1.2" fill="none"/>
                <path className="nvp-cm" d="M -1 37 L -1 32 M -1 37 L 4 37" stroke="#15A08C" strokeWidth="1.2" fill="none"/>
                <path className="nvp-cm" d="M 37 37 L 37 32 M 37 37 L 32 37" stroke="#15A08C" strokeWidth="1.2" fill="none"/>
                <rect className="nvp-beam" x="1" y="2" width="34" height="1.4" fill="#15A08C"/>
              </g>
              <text x="30" y="80" textAnchor="middle" fontSize="10" fontWeight="800" fill="#0F6E56">$312.00</text>
              <rect x="8" y="83" width="44" height="7" rx="2" fill="#15A08C"/>
              <text x="30" y="88.5" textAnchor="middle" fontSize="5" fontWeight="700" fill="#FFFFFF">Pay now</text>
              <g className="nvp-check">
                <circle cx="52" cy="36" r="3.5" fill="#15A08C"/>
                <path d="M 50.3 36 L 51.6 37.3 L 53.7 35.2" stroke="#FFFFFF" strokeWidth="0.9" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
              </g>
            </g>
          </g>

          <path d="M 115 180 Q 95 170 85 150 Q 83 145 87 143 L 93 145 Q 100 160 115 180 Z" fill="#F97066"/>
          <circle cx="88" cy="146" r="8" fill="#D4A574"/>
          <ellipse cx="155" cy="294" rx="55" ry="4" fill="#0F172A" opacity="0.1"/>
        </svg>
      </div>
    </>
  );
}